import { RedMailComponentaProps } from "../interfaces/redMailInterfaces"
import { PopUpGalhed } from "./popUp/popUpGalhed";



export interface RedMailComponentaGalhedProps extends RedMailComponentaProps {
    lang:string
}

export class RedMailComponentaGalhed extends React.Component<RedMailComponentaGalhedProps, {}> {

    public render() {
        const { handleChangeText, isTextAreaBlank, countSubmitAttempts, textArea,
                mail, phoneNumber, validation, handleChangeExtraData, isAgreementApproved,
                submitForm, submitButtonDisabled, IsPopUp, onClose, lang } = this.props;

        const isEnglish = lang === "en-GB";

        const ynetTermsHref = "https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html";
        const ynetPolicyHref = "https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html";
        const ynetTermsLink = <a href={ynetTermsHref} className="termsClick">{isEnglish ? "Terms of Use" : "תנאי השימוש"}</a>
        const ynetPolicyLink = <a href={ynetPolicyHref} className="termsClick">{isEnglish ? "Privacy Policy" : "מדיניות הפרטיות"}</a>

        const translations = {
            mainTitle: isEnglish ? "Did you find a mistake?" : "מצאתם טעות?",
            description1: isEnglish ? "We are making every effort to ensure that the information on the site is accurate and complete. If you encounter incorrect or missing information, we would appreciate it if you could write to us, and we will take action to complete and update what is necessary. It is important that you fill in all your details so that we can contact you if needed." : "אנחנו עושים את מירב המאמצים כדי שהמידע באתר יהיה מדויק וללא חוסרים. אם נתקלתם במידע שגוי או לוקה בחסר – נודה לכם שתכתבו לנו, ואנחנו נפעל כדי להשלים ולעדכן את מה שנדרש. חשוב שתמלאו את כל הפרטים שלכם, על מנת שנוכל ליצור קשר במידת הצורך.",
          
            fieldsTitle: isEnglish ? "Contact Us" : "פנו אלינו",
            fullName: isEnglish ? "Full name" : "שם מלא",
            phoneNumber: isEnglish ? "Mobile phone number" : "מספר טלפון נייד",
            email: isEnglish ? "Email address" : "כתובת דוא״ל",
            messageContent: isEnglish ? "Content of the inquiry" : "תוכן הפנייה",
            phoneError: isEnglish ? "Please enter a valid phone number" : "נא להזין מספר טלפון תקין",
            emailError: isEnglish ? "Please enter a valid email address" : "נא להזין כתובת אימייל תקינה",
            messageError: isEnglish ? "It seems you forgot to attach the message content" : "נראה ששכחת לצרף את תוכן ההודעה",
            termsText: isEnglish ? "I have read, understood and agree to the " : "קראתי, הבנתי ומסכים לאמור ב",
            termsAnd: isEnglish ? " and " : " וב",
            termsNewsletter: isEnglish ? " and to receive newsletters from ynet." : " ולקבלת דיוורים מאתר ynet.",
            termsError: isEnglish ? "You must approve the terms of use" : "יש לאשר את תנאי השימוש",
            submitButton: isEnglish ? "Send" : "שליחה"
        };

        return (
            <div className={`RedMailComponentaGalhed ${isEnglish ? "ltrSite" : ""}`}>
                <div className="galhed-contact-form">
                    {/* Right section - Title and description */}
                    <div className="form-content-section">
                        <div className="title-section">
                            <div className="title-wrapper">
                                <p className="main-title">{translations.mainTitle}</p>
                                <div className="title-underlines">
                                    <div className="white-line"></div>
                                    <div className="red-line"></div>
                                </div>
                            </div>
                        </div>
                        <div className="description-section">
                            <p className="description-text">
                                {translations.description1}
                            </p>
                        </div>
                    </div>

                    {/* Left section - Form fields */}
                    <div className="form-fields-section">
                        <p className="fields-title">{translations.fieldsTitle}</p>

                        {/* Full Name Input */}
                        <div className="input-field-wrapper">
                            <div className="input-field">
                                <input
                                    type="text"
                                    name="sender"
                                    value={this.props.sender || ''}
                                    onChange={handleChangeExtraData}
                                    placeholder=" "
                                    className="text-input"
                                    id="sender"
                                />
                                <label className="input-label" htmlFor="sender">{translations.fullName}</label>
                            </div>
                        </div>
                        {/* Phone Number Input */}
                        <div className="input-field-wrapper">
                            <div className="input-field">
                                <input
                                    type="text"
                                    value={phoneNumber}
                                    onChange={(e) => handleChangeExtraData(e)}
                                    name="phoneNumber"
                                    placeholder=" "
                                    className="text-input"
                                    id="phoneNumber"
                                />
                                <label className="input-label" htmlFor="phoneNumber">{translations.phoneNumber}</label>
                            </div>
                            {!validation.phoneNumber && phoneNumber && (
                                <div className="error-message">{translations.phoneError}</div>
                            )}
                        </div>

                        {/* Email Input */}
                        <div className="input-field-wrapper">
                            <div className="input-field">
                                <input
                                    type="email"
                                    value={mail}
                                    onChange={(e) => handleChangeExtraData(e)}
                                    name="mail"
                                    placeholder=" "
                                    className="text-input"
                                    id="mail"
                                />
                                <label className="input-label" htmlFor="mail">{translations.email}</label>
                            </div>
                            {!validation.mail && mail && (
                                <div className="error-message">{translations.emailError}</div>
                            )}
                        </div>

                        {/* Message Textarea */}
                        <div className="textarea-field-wrapper">
                            <div className="textarea-field" id="RedMailTextAreaElement">
                                <textarea
                                    value={textArea}
                                    onChange={handleChangeText}
                                    placeholder=" "
                                    className="textarea-input"
                                />
                                <label className="textarea-label">{translations.messageContent}</label>
                            </div>
                            {isTextAreaBlank && countSubmitAttempts > 0 && (
                                <div className="error-message">{translations.messageError}</div>
                            )}
                        </div>

                        {/* Terms Checkbox */}
                        <div className="terms-wrapper">
                            <div className="checkbox-wrapper">
                                <input
                                   
                                    id="agreementApproved"
                                    type="checkbox"
                                    checked={isAgreementApproved}
                                    onChange={(e) => handleChangeExtraData(e)}
                                    className="checkBox"
                                />
                                
                            </div>
                            <p className="terms-text">
                                {translations.termsText}{ynetTermsLink}{translations.termsAnd}{ynetPolicyLink}{translations.termsNewsletter}
                            </p>
                        </div>
                        {!isAgreementApproved && countSubmitAttempts > 0 && (
                            <div className="error-message terms-error">{translations.termsError}</div>
                        )}

                        {/* Submit Button */}
                        <button
                            disabled={submitButtonDisabled}
                            className="submit-button"
                            type="submit"
                            onClick={submitForm}
                        >
                            {translations.submitButton}
                        </button>
                    </div>
                </div>
                  {IsPopUp && <PopUpGalhed onClose={onClose} lang={lang} />}
            </div>
        );
    }
}
